import { UseMutationResult, useMutation } from "@tanstack/react-query";
import { Methods } from "../../constants/CommonConstants";
import Api from "../axios";
import { EndPoints } from "../endPoints";
import { handleApiResponseErrors } from "../HandleAPIResponseErrors";
import { GeneralResponse } from "../../../types/api";
import { ICheckNumberRequest } from "../../../types/apis/auth-apis";

export const CheckFromNumber = async (
  payload: ICheckNumberRequest,
): Promise<GeneralResponse> => {
  try {
    const response = await Api<any, GeneralResponse<ICheckNumberRequest>>({
      method: Methods.POST,
      endpoint: EndPoints.checkFromNumber,
      body: payload,
    });
    handleApiResponseErrors(response, "validation_error");
    return response;
  } catch (error) {
    console.error("API Error:", error);
    throw error;
  }
};

export const useCheckFromNumber = (options = {}) => {
  const mutation: UseMutationResult<
    GeneralResponse,
    Error,
    ICheckNumberRequest
  > = useMutation({
    mutationFn: CheckFromNumber,
    ...options,
  });
  return {
    data: mutation.data,
    error: mutation.error,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    mutate: mutation.mutate,
    reset: mutation.reset,
    status: mutation.status,
  };
};
